import React from "react";
import "./Menu.css";
import { Link } from "react-scroll";
import Portfolio_pic from "../../assets/images/Portfolio pic.jpg";
import Zoom from "react-reveal/Zoom";
import Fade from "react-reveal/Fade";
import {
  FcAbout,
  FcContacts,
  FcEngineering,
  FcHome,
  FcReading,
} from "react-icons/fc";
import { MdConstruction } from "react-icons/md";
const Menu = ({ toggle }) => {
  return (
    <>
      {toggle ? (
        <>
          <Zoom>
            <div className="navbar-profile-pic">
              <img src={Portfolio_pic} alt="profile pic" />
            </div>
          </Zoom>
          <Fade left>
            <div className="nav-items">
              <div className="nav-item">
                <div className="nav-link ">
                  <Link
                    className="menulink"
                    to="home"
                    spy={true}
                    smooth={true}
                    offset={0}
                  >
                    <FcHome size={18} />
                    Home
                  </Link>
                </div>
                <div className="nav-link">
                  <Link
                    className="menulink"
                    to="about"
                    spy={true}
                    // style={{ color: "white" }}
                    smooth={true}
                    offset={-60}
                  >
                    <FcAbout size={18} />
                    About
                  </Link>
                </div>

                <div className="nav-link">
                  <Link
                    to="tech"
                    className="menulink"
                    spy={true}
                    // style={{ color: "white" }}
                    smooth={true}
                    offset={-60}
                  >
                    <FcEngineering size={18} />
                    Tech Stack
                  </Link>
                </div>
                <div className="nav-link">
                  <Link
                    to="education"
                    className="menulink"
                    spy={true}
                    // style={{ color: "white" }}
                    smooth={true}
                    offset={0}
                  >
                    <FcReading size={18} />
                    Education
                  </Link>
                </div>
                <div className="nav-link">
                  <Link
                    to="projects"
                    className="menulink"
                    spy={true}
                    // style={{ color: "white" }}
                    smooth={true}
                    offset={-40}
                  >
                    <MdConstruction size={18} />
                    Projects
                  </Link>
                </div>
                <div className="nav-link ">
                  <Link
                    to="contact"
                    className="menulink"
                    spy={true}
                    // style={{ color: "white" }}
                    smooth={true}
                    offset={-70}
                  >
                    <FcContacts size={18} />
                    Contact
                  </Link>
                </div>
              </div>
            </div>
          </Fade>
        </>
      ) : (
        <>
          <div className="nav-items">
            <div className="nav-item">
              <div className="nav-link">
                <Link to="home" spy={true} smooth={true} offset={-10}>
                  <FcHome title="home" size={25} />
                </Link>
              </div>
              <div className="nav-link">
                <Link to="about" spy={true} smooth={true} offset={-60}>
                  <FcAbout title="about me" size={25} />
                </Link>
              </div>

              <div className="nav-link">
                <Link to="tech" spy={true} smooth={true} offset={-60}>
                  <FcEngineering title="tech stack" size={25} />
                </Link>
              </div>
              <div className="nav-link">
                <Link to="education" spy={true} smooth={true} offset={0}>
                  <FcReading title="Education" size={25} />
                </Link>
              </div>
              <div className="nav-link">
                <Link to="projects" spy={true} smooth={true} offset={-30}>
                  <MdConstruction title="Projects" size={25} />
                </Link>
              </div>
              <div className="nav-link">
                <Link to="contact" spy={true} smooth={true} offset={-80}>
                  <FcContacts title="Contact" size={25} />
                </Link>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default Menu;
